import React, { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Bold, Italic, Underline, Heading2, Heading3, List, ListOrdered, Quote, Link2, Image as ImageIcon, Eraser } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Editor de texto simples (negrito, títulos, listas, link, imagem). O servidor limpa o HTML ao salvar. */
export function RichText({ value, onChange, minHeight = 260, testid = "lesson-richtext" }) {
  const ref = useRef(null);
  const imgRef = useRef(null);
  useEffect(() => { if (ref.current && ref.current.innerHTML !== value) ref.current.innerHTML = value || ""; }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const cmd = (c, v = null) => { ref.current?.focus(); document.execCommand(c, false, v); onChange(ref.current.innerHTML); };
  const link = () => { const url = window.prompt("Endereço do link (https://...)"); if (url) cmd("createLink", url); };
  const uploadImg = async (files) => {
    const file = files?.[0]; if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { const r = await api.post("/upload", fd); cmd("insertImage", `${BACKEND}${r.data.url}`); }
    catch (e) { toast.error("Falha ao enviar imagem."); }
    finally { if (imgRef.current) imgRef.current.value = ""; }
  };
  const B = ({ icon: I, on, title }) => <button type="button" title={title} onMouseDown={(e) => { e.preventDefault(); on(); }} className="p-2 rounded hover:bg-slate-100 text-slate-600"><I className="h-4 w-4" /></button>;
  return (
    <div className="rounded-lg border border-slate-200 overflow-hidden">
      <div className="flex flex-wrap gap-0.5 border-b border-slate-200 bg-slate-50 px-1 py-1">
        <B icon={Bold} title="Negrito" on={() => cmd("bold")} /><B icon={Italic} title="Itálico" on={() => cmd("italic")} />
        <B icon={Underline} title="Sublinhado" on={() => cmd("underline")} />
        <B icon={Heading2} title="Título" on={() => cmd("formatBlock", "h2")} /><B icon={Heading3} title="Subtítulo" on={() => cmd("formatBlock", "h3")} />
        <B icon={List} title="Lista" on={() => cmd("insertUnorderedList")} /><B icon={ListOrdered} title="Lista numerada" on={() => cmd("insertOrderedList")} />
        <B icon={Quote} title="Citação" on={() => cmd("formatBlock", "blockquote")} /><B icon={Link2} title="Link" on={link} />
        <B icon={ImageIcon} title="Imagem" on={() => imgRef.current?.click()} /><B icon={Eraser} title="Limpar formatação" on={() => cmd("removeFormat")} />
        <input ref={imgRef} type="file" accept="image/*" className="hidden" onChange={(e) => uploadImg(e.target.files)} />
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning onInput={() => onChange(ref.current.innerHTML)}
        style={{ minHeight }} className="lesson-html p-4 text-sm text-slate-700 focus:outline-none" data-testid={testid} />
    </div>
  );
}

